module.exports = __webpack_public_path__ + "img/autografika.5b17d354.jpg";